var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_715_3961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 7.5C1.875 7.99728 2.07254 8.47419 2.42417 8.82583C2.77581 9.17746 3.25272 9.375 3.75 9.375C4.24728 9.375 4.72419 9.17746 5.07583 8.82583C5.42746 8.47419 5.625 7.99728 5.625 7.5C5.625 7.00272 5.42746 6.52581 5.07583 6.17417C4.72419 5.82254 4.24728 5.625 3.75 5.625C3.25272 5.625 2.77581 5.82254 2.42417 6.17417C2.07254 6.52581 1.875 7.00272 1.875 7.5Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.75C9.375 4.24728 9.57254 4.72419 9.92417 5.07583C10.2758 5.42746 10.7527 5.625 11.25 5.625C11.7473 5.625 12.2242 5.42746 12.5758 5.07583C12.9275 4.72419 13.125 4.24728 13.125 3.75C13.125 3.25272 12.9275 2.77581 12.5758 2.42417C12.2242 2.07254 11.7473 1.875 11.25 1.875C10.7527 1.875 10.2758 2.07254 9.92417 2.42417C9.57254 2.77581 9.375 3.25272 9.375 3.75Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.25C9.375 11.7473 9.57254 12.2242 9.92417 12.5758C10.2758 12.9275 10.7527 13.125 11.25 13.125C11.7473 13.125 12.2242 12.9275 12.5758 12.5758C12.9275 12.2242 13.125 11.7473 13.125 11.25C13.125 10.7527 12.9275 10.2758 12.5758 9.92417C12.2242 9.57254 11.7473 9.375 11.25 9.375C10.7527 9.375 10.2758 9.57254 9.92417 9.92417C9.57254 10.2758 9.375 10.7527 9.375 11.25Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 6.6875L9.5625 4.5625",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 8.3125L9.5625 10.4375",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_715_3961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShares);
export default __webpack_public_path__ + "static/media/shares.185a141c871913e063d30bdb0f8faeb6.svg";
export { ForwardRef as ReactComponent };